import React, { useCallback, useEffect } from 'react';
import queryString from 'query-string';
import { isEmpty as _isEmpty } from 'lodash-es';
import { useDispatch, useSelector } from 'react-redux';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { postDataFromApiAction } from 'components/Atoms/GraasApiUtility/GraasApiUtility.action';
import { apiServices } from 'redux/utils/api_services';
import { checkAndCreateDashboard } from '../../Modules/Connect/utility';
import SMResult from 'components/Atoms/SMResult/SMResult';

const OAuth = () => {
  const { t } = useTranslation();
  const parsedQueryString = queryString.parse(window.location.search);
  const dispatch = useDispatch();
  const userDetails = useSelector(state => state.User?.accountDetails);

  const initiateOauth = useCallback(async () => {
    const parsedQueryString = queryString.parse(window.location.search);
    let channel = '';
    let payload = {};
    if (
      !_isEmpty(parsedQueryString?.code) &&
      !_isEmpty(parsedQueryString?.state) &&
      !_isEmpty(parsedQueryString?.action)
    ) {
      channel = 'lazada';
      payload.code = parsedQueryString?.code;
      payload.requestFrom = 'graas';
      // chat or ERP
      payload.appType = parsedQueryString?.app_type || 'ERP';
    } else {
      channel = 'shopify';
      payload.hmac = parsedQueryString?.hmac;
      payload.host = parsedQueryString?.host;
      payload.shop = parsedQueryString?.shop;
      payload.timestamp = parsedQueryString?.timestamp;
      payload.session = parsedQueryString?.session;
    }
    if (!_isEmpty(parsedQueryString)) {
      if (parsedQueryString?.success) {
      }
    }
    const apiUrl = `${apiServices['account']}/services/linkAccount/initiate/${channel}`;
    const response = await postDataFromApiAction(apiUrl, payload);
    if (response?.hasError) {
      message.error(`${t('GRAAS_FAILED_TO_CONNECT_GRAAS')}`);
    } else {
      await checkAndCreateDashboard(dispatch, userDetails?.countryCode, channel);
      const { url } = response;
      window.location.assign(url);
    }
  }, [userDetails]);

  const verifyOauthFlow = useCallback(
    async (payload, channel) => {
      const apiUrl = `${apiServices['account']}/services/linkAccount/initiate/${channel}`;
      const apiResponse = await postDataFromApiAction(apiUrl, payload);
      console.log(apiResponse);
      if (apiResponse?.response !== 'success' || apiResponse?.hasError || !apiResponse?.url) {
        message.error(apiResponse?.responseMessage || `${channel} - ${t('GRAAS_FAILED_TO_CONNECT_GRAAS')}`);
      } else {
        window.history.replaceState(null, null, apiResponse?.url);
      }
    },
    [t]
  );

  useEffect(() => {
    initiateOauth();
  }, []);

  return (
    <>
      <SMResult type='loader' message="We are processing the request. Please don't refresh the page." />
    </>
  );
};

export default OAuth;
